import React, { Component } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from 'reactstrap';
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Pagina from "componentes/Pagina";
import ProcessoDetalhe from "componentes/ProcessoDetalhe";
import ProcessoParecerForm from "componentes/ProcessoParecerForm";
import {
  quandoMudar,
  salvar
} from "./actions";
import { buscarProcesso } from "paginas/processo/actions";

class Parecer extends Component {
  componentDidMount() {
    const { processoIdRota, processoId, buscarProcesso } = this.props;
    if (!processoId || (processoIdRota && processoIdRota !== processoId)) {
      buscarProcesso(processoIdRota);
    }
  }
  render() {
    return (
      <Pagina title="Elaborar Parecer" breadcrumbs={[
        { name: "Tramitar Processo" },
        { name: "Emitir Parecer", active: true }
      ]} >
        <ProcessoDetalhe />
        <Card tag="fieldset">
            <CardHeader tag="legend">Parecer</CardHeader>
            <CardBody>
              <ProcessoParecerForm {...this.props} />
            </CardBody>
        </Card>  
      </Pagina>
    );
  }
}

const mapStateToProps = (state, { history, match: { params: { id: processoIdRota, parecerId } } }) => ({
  parecerIdRota: parecerId ? parseInt(parecerId, 10) : "",
  processoIdRota: processoIdRota ? parseInt(processoIdRota, 10) : "",
  processoId: state.processo.processo.id,
  history,
  parecer: state.parecer.parecer,
  situacoes: state.parecer.situacoes
});

const mapDispatchToProps = dispatch => bindActionCreators({
  buscarProcesso,
  quandoMudar,
  salvar
}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Parecer))


// WEBPACK FOOTER //
// ./src/paginas/parecer/index.js